import { LayerTypeSelectionDetailViewProps } from "react-migration/layouts/map/Multilayer/types";
import { useDesignationById } from "react-migration/domains/constraints/designation/hooks/useDesignationById";
import { SkeletonLoading } from "react-migration/components/SkeletonLoading";
import { TrafficCountPanel } from "../components/TrafficCountPanel";

export function TrafficSelectionDetailView({ selection }: LayerTypeSelectionDetailViewProps) {
  const { designation, ...designationQuery } = useDesignationById(selection.id);

  if (designationQuery.loading || !designation) {
    return (
      <div className="overflow-auto bg-white">
        <div className="relative m-3 min-h-96" data-testid="designation-body-loading">
          <SkeletonLoading rows={3} showPadding={false} />
        </div>
      </div>
    );
  }

  return <TrafficCountPanel designationData={designation} />;
}
